import { useMemo } from 'react'
import { Grid } from '@mui/material'

import { PageContentLayout } from '@layouts/PageContentLayout'
import { AppLoader } from '@components/AppLoader'

import { LocalEventBus } from '../../events'

import { Section } from './components/Section'
import { useWindow } from './hooks'

type WindowProps = {
  dialogId: string
  id: string
}

export const Window = ({ dialogId, id }: WindowProps) => {
  const localEventBus = useMemo(() => new LocalEventBus(), [])

  const {
    data: { sectionRows, initialCommonParameters, windowVariables },
    state: { currentDialogWindow, dialogWindows, isLoadingWindowById },
  } = useWindow(id, localEventBus)

  if (isLoadingWindowById) {
    return <AppLoader />
  }

  return (
    <PageContentLayout>
      <Grid container sx={{ height: '100%' }}>
        {sectionRows.map(row => (
          <Grid key={`row-${row.line}`} container item sx={{ p: 0.5, height: '50%' }} xs={12}>
            {row.columns.map(col => (
              <Grid
                key={`col-${col.column}`}
                container
                item
                sx={{ p: 0.5, height: '100%' }}
                xs={col.size}
              >
                <Section
                  commonParameters={initialCommonParameters}
                  currentDialogWindow={currentDialogWindow}
                  data={col}
                  dialogId={dialogId}
                  dialogWindows={dialogWindows}
                  localEventBus={localEventBus}
                  windowVariables={windowVariables}
                />
              </Grid>
            ))}
          </Grid>
        ))}
      </Grid>
    </PageContentLayout>
  )
}
